<script lang="ts">
  import DealProductRow from "./DealProductRow.svelte";
  import type { Product } from "@shared/types/ProductLine";
  import type { DealTier } from "@shared/types/Deals";

  export let dealTier: DealTier;
  export let dealActive: boolean = false;
  export let products: { [key: number]: Product };
  export let isRip: boolean = false;
</script>

<table class="fizz-table fizz-text-medium">
  <thead>
    <tr>
      <th>Product</th>
      <th>List Price</th>
      {#if !isRip}
        <th>Deal Price</th>
      {/if}
      {#if dealActive}
        <th width="300">Items In Cart</th>
      {/if}
    </tr>
  </thead>
  <tbody>
    {#if dealTier && dealTier != undefined && dealTier.discounts}
      {#each dealTier.discounts as discount}
        {#if discount.active_discount}
          <DealProductRow {products} {discount} {dealActive} {isRip} />
        {/if}
      {/each}
    {/if}
  </tbody>
</table>
